import {
  AssignTechWriterRequest,
  AssignTechWriterResponse,
  AssignBarRaiserRequest,
  AssignBarRaiserResponse,
  Attachment,
  Content,
  ContentAudience,
  ContentEngagement,
  ContentMetadata,
  CommentConversion,
  ContentPriority,
  ContentRequestData,
  ContentRequestState,
  ContentRequestUpdateConfig,
  ContentType,
  ContentWorkflow,
  ContentWorkingCopy,
  CreateContentEngagementRequest,
  CreateContentEngagementResponse,
  CreateContentNoteRequest,
  CreateContentNoteResponse,
  CreateContentRequestRequest,
  CreateContentRequestResponse,
  CreateContentThreadRequest,
  CreateContentThreadResponse,
  CreateContentWorkingCopyRequest,
  CreateContentWorkingCopyResponse,
  CreateDraftContentRequest,
  CreateDraftContentResponse,
  CreatePublicationCommentResponse,
  CreateReplyCommentRequest,
  CreateReplyCommentResponse,
  CreateWorkflowEventRequest,
  CreateWorkflowEventResponse,
  DeleteContentNoteResponse,
  DeleteContentPriorityResponse,
  DeleteContentRequestRequest,
  DeleteUserCommentRequest,
  DeleteUserCommentResponse,
  FeedbackData,
  GetAttachmentInfoResponse,
  GetContentEngagementResponse,
  GetContentEngagementStatsResponse,
  GetContentNoteStatsResponse,
  GetContentRequestResponse,
  GetContentTemplateResponse,
  GetContentWorkingCopyResponse,
  GetDraftContentResponse,
  GetPublicationResponse,
  GetUserProfileResponse,
  GetUserProfilesResponse,
  GetWorkflowEventResponse,
  GetWorkflowHistoryResponse,
  ListContentAccessResponse,
  ListContentEngagementResponse,
  ListContentNotesResponse,
  ListContentRequestsResponse,
  ListContentReviewersResponse,
  ListContentsToReviewResponse,
  ListContentWorkingCopyResponse,
  ListDraftContentsResponse,
  ListFinalizingPublicationResponse,
  ListPublicationCommentsResponse,
  ListPublicationCommentsToReviewResponse,
  ListPublicationsResponse,
  ListSharedContentsResponse,
  ListThreadRepliesRequest,
  ListThreadRepliesResponse,
  ListThreadsRequest,
  ListThreadsResponse,
  ListWorkflowEventsResponse,
  ListWorkflowHistoryResponse,
  ListPublicationFeedbacksResponse,
  PublicationComment,
  PublicationCommentState,
  SearchPublicationsResponse,
  ShareContentsRequest,
  ShareContentsResponse,
  UpdateCommentSectionsRequest,
  UpdateCommentSectionsResponse,
  UpdateContentAudienceRequest,
  UpdateContentAudienceResponse,
  UpdateContentEngagementRequest,
  UpdateContentEngagementResponse,
  UpdateContentMetadataDomainRequest,
  UpdateContentMetadataDomainResponse,
  UpdateContentNoteRequest,
  UpdateContentNoteResponse,
  UpdateContentPriorityRequest,
  UpdateContentPriorityResponse,
  UpdateContentRankRequest,
  UpdateContentRankResponse,
  UpdateContentRequestRequest,
  UpdateContentRequestResponse,
  UpdateContentReviewersRequest,
  UpdateContentReviewersResponse,
  UpdateFinalizingContentRequest,
  UpdateUserCommentResponse,
  UpdateProposalResponse,
  UpdatePublicationFeedbackRequest,
  UpdatePublicationFeedbackResponse,
  UserCommentState,
  UserRoles,
  WorkflowEventData,
  WorkflowEventTypes,
  WorkflowState,
  WorkingCopyKey,
  ListContentsReviewedByUserResponse,
  CreateAPGLUserProfileRequest,
  CreateAPGLUserProfileResponse,
  ListAPGLUserProfilesResponse,
  GetAPGLUserProfileResponse,
  UpdateAPGLUserProfileResponse,
  UpdateAPGLUserProfileRequest,
  APGLUserProfileAttributes,
  CreatePublicationFeedbackRequest,
  DuplicationResultsResponse,
  GetDuplicationResultsResponse,
  PublicationIssueType,
  ListEnabledFeaturesResponse,
  UpdateContentTagsRequest,
  UpdateContentTagsResponse,
  WorkflowTag,
  APGLUserProfileRecordSubType,
  GetPublicationPDFResponse,
  UpdateUserRoleRequest,
  ContentUserRoleDefinition,
  TechWriterStatus,
  DeleteTechWriterStatusResponse,
  UpdateTechWriterStatusRequest,
  UpdateTechWriterStatusResponse,
  TechDomain,
  AWSService,
  PublicationFeedbackState,
  PublicationFeedbackData,
  DraftContentQueryConditions,
  QueryDraftContentsRequest,
  GetPublishedContentVersionsRequest,
  UpdatePublishedContentVersionRequest,
  GetPublishedContentVersionsResponse,
  UpdatePublishedContentVersionResponse,
  DeletePublicationVersionResponse,
  GetContentWorkflowResponse,
  GetContentQualityQuestionsRequest,
  GetContentQualityQuestionsResponse,
  CreateContentQualityEvaluationResponse,
  QuestionnaireResponses,
  CreateContentQualityEvaluationRequest,
  GetContentQualityEvaluationResponse,
  GetContentQualityEvaluationRequest,
  GetInlineEditsResponse,
  InlineEditResolution,
  ResolveInlineEditResponse,
  BulkResolveInlineEditsResponse,
  ListInlineCommentRequest,
  ListInlineCommentResponse,
  UpdateInlineCommentsAttributes,
  UpdateInlineCommentsResponse,
  DeleteInlineCommentRequest,
  DeleteInlineCommentResponse,
  UserCommentType,
  CreateInlineCommentRequest,
  CreateInlineCommentResponse,
  UpdateMetadataRequest,
  UpdateMetadataResponse,
  CollectionAudience,
  CreateCollectionRequest,
  CreateCollectionResponse,
  GetCollectionResponse,
  ListCollectionsResponse,
  Collection,
  PublishCollectionRequest,
  PublishCollectionResponse,
  ListPublicCollectionResponse,
  EditCollectionRequest,
  EditCollectionResponse,
  CreateCollectionEventRequest,
  CreateCollectionEventResponse,
  CollectionEventType,
  DeleteCollectionResponse,
  AddCollectionOwnerResponse,
  RemoveCollectionOwnerResponse,
  BarRaiserStatus,
  DeleteBarRaiserStatusResponse,
  UpdateBarRaiserStatusResponse,
  UpdateBarRaiserStatusRequest,
  UnpublishCollectionResponse,
  GetDiagramGuidelinesDeckResponse,
  EngagementSource,
  GetBarRaiserLeaderboardResponse,
  BarRaiserFilter,
  FeedbackItemStatistics,
  SubmitFeedbackRequest,
  DeleteFeedbackRequest,
  ListFeedbackRequest,
  FeedbackItem,
  GetFeedbackByUserRequest,
  ListFeedbackStatisticsResponse,
  SubmitDeleteFeedbackResponse,
  GetFeedbackByUserResponse,
  UserType,
} from '@amzn/awscat-pattern-library-service-model';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import axiosBetterStacktrace from 'axios-better-stacktrace';
import { DateTime } from 'luxon';
import mime from 'mime';
import queryString from 'query-string';
import { v4 as uuid } from 'uuid';
import AuthenticationManager from '../common/AuthenticationManager';
import EnvironmentConfig, { isFeatureEnabled } from '../common/EnvironmentConfig';
import JSONSerializer from '../common/JSONSerializer';
import { flashbar } from '../decorators/flashbar';
import { localLog } from '../loggers/Logger';
import Publication from '../model/Publication';
import type { IMplServiceClient, PostWorkflowEventOptions } from './IMplServiceClient';
import { updateProposal as updateProposalSSE } from './UpdateProposal';
import { Buffer } from 'buffer';
import { DEFAULT_FLASHBAR_TIMEOUT } from '../common/FlashbarMessageBroker';
import { stripWorkloadNotApplicable } from '../components/utils/SelectableOptions';

/**
 * @deprecated Legacy client coupling transport with the global flashbar via the
 * `@flashbar` decorator. New v2 code uses {@link MplServiceClientV2}, which
 * throws typed `ServiceCallError`s and has no UI coupling. Removed once v1 is retired.
 */
class MplServiceClient implements IMplServiceClient {
  private serializer: JSONSerializer;
  private svc: AxiosInstance;
  private envConfig: { mplServiceEndpoint: string };
  private authenticationManager: AuthenticationManager;

  public constructor() {
    this.envConfig = EnvironmentConfig.getConfig();
    this.svc = axios.create({
      baseURL: this.envConfig.mplServiceEndpoint,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      timeout: 120000,
    });
    axiosBetterStacktrace(this.svc);
    this.authenticationManager = AuthenticationManager.create();
    this.svc.interceptors.response.use(
      (res) => res,
      (err) => {
        const originalRequest = err.config;
        localLog.debug({ err }, 'APG service client response error intercepted.');
        if (
          err &&
          err.response &&
          err.response.status &&
          err.response.status === 401 &&
          originalRequest
        ) {
          localLog.debug('APG service error is 401');
          if (!originalRequest._retry) {
            originalRequest._retry = true;
            localLog.debug('Attempting to refresh authentication token and retrying requests...');
            // @ts-expect-error TS7030 - strict migration
            return this.authenticationManager.renewAuthorInfo().then((authInfo) => {
              if (authInfo) {
                this.setAuthentication(authInfo.tokenInfo.token);
                originalRequest.headers.Authorization = `Bearer ${authInfo.tokenInfo.token}`;
                return axios(originalRequest);
              }
            });
          }
        }

        // Any other error is just passed through
        // Include HTTP URL, Method and UserId for better RUM debugging.
        const stack = err?.stack?.split('at');
        if (Array.isArray(stack)) {
          stack.splice(1, 0, ` url: ${err.config?.url}\n`);
          stack.splice(2, 0, ` method: ${err.config?.method}\n`);
          stack.splice(
            3,
            0,
            ` userId: ${this.authenticationManager?.authInfo?.userProfile?.userId}\n`,
          );
          err.stack = stack.join('at');
        }
        return Promise.reject(err);
      },
    );

    this.serializer = new JSONSerializer();
  }

  public setAuthentication(token: string) {
    this.svc.defaults.headers.common.Authorization = `Bearer ${token}`;
    this.svc.defaults.headers.common['x-auth-provider'] = 'catportal';
  }

  @flashbar({ error: 'Failed to fetch categories configuration.' })
  public async getCategories() {
    const response = await this.svc.get('/categories');
    return response.data.categories;
  }

  /*************************************************** Workflow APIs ****************************************************************/

  @flashbar({
    success: (...args) => {
      const options = args[7] as PostWorkflowEventOptions | undefined;
      return options?.suppressSuccessFlashbar
        ? undefined
        : 'Successfully created review workflow event.';
    },
    error: (e) =>
      e?.response?.status === 403
        ? {
            status: e?.response?.status,
            message: 'You do not have permission to create this workflow event.',
          }
        : { status: e?.response?.status, message: 'Failed to create review workflow event.' },
  })
  public async postWorkflowEvent(
    contentId: string,
    workflowId: number,
    event: WorkflowEventTypes,
    comment: string,
    data?: WorkflowEventData,
    evaluation?: QuestionnaireResponses,
    score?: number,
    _options?: PostWorkflowEventOptions,
  ) {
    if (!contentId || !workflowId || !event) {
      throw Error(
        `Invalid workflow event parameters. contentID: ${contentId} workflowID: ${workflowId} event: ${event} comment: ${comment}`,
      );
    }

    const requestData: CreateWorkflowEventRequest = CreateWorkflowEventRequest.create(
      contentId,
      workflowId,
      event,
      comment,
    );
    requestData.data = data;
    requestData.evaluation = evaluation;
    requestData.score = score;

    const response = await this.svc.post(
      `/contents/${contentId}/events/${workflowId}`,
      this.serializer.serialize(requestData),
    );
    return this.serializer.deserialize<CreateWorkflowEventResponse>(
      response.data,
      CreateWorkflowEventResponse,
    );
  }

  public async getWorkflowEvent(eventId: string): Promise<GetWorkflowEventResponse> {
    const response = await this.svc.get(`/events/${eventId}`);
    return this.serializer.deserialize<GetWorkflowEventResponse>(
      response.data,
      GetWorkflowEventResponse,
    );
  }

  @flashbar({
    success: 'Successfully re-enabled workflow actions.',
    error: (e) =>
      e?.response?.status === 403
        ? {
            status: e?.response?.status,
            message:
              'You do not have permission to unlock the content. TW can only unlock content in FINALIZING/FINALIZED stage.',
          }
        : { status: e?.response?.status, message: 'Failed to re-enable workflow actions.' },
  })
  public async unlockWorkflow(contentId: string): Promise<any> {
    const response = await this.svc.delete(`/contents/${contentId}/lock`);
    return response.data;
  }

  @flashbar({ error: 'Failed to update workflow content audience.' })
  public async updateWorkflowContentAudience(
    contentId: string,
    contentAudience: ContentAudience,
  ): Promise<UpdateContentAudienceResponse> {
    const request = UpdateContentAudienceRequest.create(contentId, contentAudience);
    const response = await this.svc.patch(
      `/contents/${contentId}/content-audience`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateContentAudienceResponse>(
      response.data,
      UpdateContentAudienceResponse,
    );
  }

  @flashbar({ error: 'Failed to update workflow content audience.' })
  public async updateWorkflowTags(
    contentId: string,
    tags: Set<WorkflowTag>,
  ): Promise<UpdateContentTagsResponse> {
    const request = UpdateContentTagsRequest.create(contentId, tags);
    const response = await this.svc.patch(
      `/contents/${contentId}/tags`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateContentTagsResponse>(
      response.data,
      UpdateContentTagsResponse,
    );
  }

  @flashbar({ error: 'Failed to update workflow rank.' })
  public async updateWorkflowRank(
    contentId: string,
    rank: number,
  ): Promise<UpdateContentRankResponse> {
    const request = UpdateContentRankRequest.create(contentId, rank);
    const response = await this.svc.patch(
      `/contents/${contentId}/rank`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateContentRankResponse>(
      response.data,
      UpdateContentRankResponse,
    );
  }

  @flashbar({ error: 'Failed to update technology domains.' })
  public async updateContentTemplateMetadataTechDomains(
    contentId: string,
    version: number,
    mainTechDomain: TechDomain,
    techDomains?: TechDomain[],
  ) {
    const request = UpdateContentMetadataDomainRequest.create(
      contentId,
      version,
      mainTechDomain,
      techDomains,
    );
    const response = await this.svc.patch(
      `/contents/${contentId}/templateMetadataTechDomains`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateContentMetadataDomainResponse>(
      response.data,
      UpdateContentMetadataDomainResponse,
    );
  }

  @flashbar({ error: 'Failed to assign bar raiser.' })
  public async assignBarRaiser(
    contentId: string,
    workflowId: number,
    userId: string,
  ): Promise<AssignBarRaiserResponse> {
    const request = AssignBarRaiserRequest.create(contentId, workflowId, userId);
    const response = await this.svc.put(
      `/review-requests/bar-raiser`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<AssignBarRaiserResponse>(
      response.data,
      AssignBarRaiserResponse,
    );
  }

  @flashbar({ error: 'Failed to delete bar raiser status.' })
  public async deleteBarRaiserStatus(
    contentId: string,
    workflowId: number,
  ): Promise<DeleteBarRaiserStatusResponse> {
    const response = await this.svc.delete(`/contents/${contentId}/${workflowId}/barRaiserStatus`);
    return this.serializer.deserialize<DeleteBarRaiserStatusResponse>(
      response.data,
      DeleteBarRaiserStatusResponse,
    );
  }

  @flashbar({ error: 'Failed to update bar raiser status.' })
  public async updateBarRaiserStatus(
    contentId: string,
    workflowId: number,
    status: BarRaiserStatus,
  ): Promise<UpdateBarRaiserStatusResponse> {
    const request = UpdateBarRaiserStatusRequest.create(contentId, workflowId, status);
    const response = await this.svc.patch(
      `/contents/${contentId}/${workflowId}/barRaiserStatus`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateBarRaiserStatusResponse>(
      response.data,
      UpdateBarRaiserStatusResponse,
    );
  }

  @flashbar({ error: 'Failed to assign tech writer.' })
  public async assignTechWriter(
    contentId: string,
    workflowId: number,
    userId: string,
  ): Promise<AssignTechWriterResponse> {
    const request = AssignTechWriterRequest.create(contentId, workflowId, userId);
    const response = await this.svc.put(
      `/review-requests/tech-writer`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<AssignTechWriterResponse>(
      response.data,
      AssignTechWriterResponse,
    );
  }

  @flashbar({ error: 'Failed to delete tech writer status.' })
  public async deleteTechWriterStatus(
    contentId: string,
    workflowId: number,
  ): Promise<DeleteTechWriterStatusResponse> {
    const response = await this.svc.delete(
      `/publications/${contentId}/${workflowId}/techWriterStatus`,
    );
    return this.serializer.deserialize<DeleteTechWriterStatusResponse>(
      response.data,
      DeleteTechWriterStatusResponse,
    );
  }

  @flashbar({ error: 'Failed to update tech writer status.' })
  public async updateTechWriterStatus(
    contentId: string,
    workflowId: number,
    status: TechWriterStatus,
  ): Promise<UpdateTechWriterStatusResponse> {
    const request = UpdateTechWriterStatusRequest.create(contentId, workflowId, status);
    const response = await this.svc.patch(
      `/publications/${contentId}/${workflowId}/techWriterStatus`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateTechWriterStatusResponse>(
      response.data,
      UpdateTechWriterStatusResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated content priority.',
    error: (e) =>
      e?.response?.status === 403
        ? {
            status: e?.response?.status,
            message: 'You do not have permission to delete content priority.',
          }
        : { status: e?.response?.status, message: 'Failed to delete content priority.' },
  })
  public async deleteContentPriority(contentId: string): Promise<DeleteContentPriorityResponse> {
    const response = await this.svc.delete(`/contents/${contentId}/priority`);
    return this.serializer.deserialize<DeleteContentPriorityResponse>(
      response.data,
      DeleteContentPriorityResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated content priority.',
    error: (e) =>
      e?.response?.status === 403
        ? {
            status: e?.response?.status,
            message: 'You do not have permission to update content priority.',
          }
        : { status: e?.response?.status, message: 'Failed to update content priority.' },
  })
  public async updateContentPriority(
    contentId: string,
    contentPriority: ContentPriority,
  ): Promise<UpdateContentPriorityResponse> {
    const request = UpdateContentPriorityRequest.create(contentId, contentPriority);
    const response = await this.svc.patch(
      `/contents/${contentId}/priority`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateContentPriorityResponse>(
      response.data,
      UpdateContentPriorityResponse,
    );
  }

  @flashbar({ error: 'Failed to get previous publication versions.' })
  public async getPublishedContent(contentId: string, contentType: ContentType): Promise<any> {
    const request = GetPublishedContentVersionsRequest.create(contentId, contentType);
    const response = await this.svc.get(`/published-content/${contentId}/${contentType}`);
    return this.serializer.deserialize<GetPublishedContentVersionsResponse>(
      response.data,
      GetPublishedContentVersionsResponse,
    );
  }

  @flashbar({ error: 'Failed to restore previous published content version' })
  public async updatePublishedContentVersion(
    contentId: string,
    contentType: ContentType,
    versionId: string,
  ) {
    const request = UpdatePublishedContentVersionRequest.create(contentId, contentType, versionId);
    const response = await this.svc.patch(
      `/published-content/${contentId}/${contentType}`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdatePublishedContentVersionResponse>(
      response.data,
      UpdatePublishedContentVersionResponse,
    );
  }

  /*************************************************** Content APIs ****************************************************************/

  @flashbar({ error: 'Failed to create new content', success: 'Your content has been created.' })
  public async createContent(
    content: Content,
    contentAudience: ContentAudience,
    isTest: boolean = false,
  ): Promise<CreateDraftContentResponse> {
    const sanitized = this.sanitizeWorkload(content);
    const request = CreateDraftContentRequest.create(sanitized, contentAudience, isTest);
    const response = await this.svc.post('/contents', this.serializer.serialize(request));
    return this.serializer.deserialize<CreateDraftContentResponse>(
      response.data,
      CreateDraftContentResponse,
    );
  }

  @flashbar({ error: 'Failed to create new content', success: 'Your content has been created.' })
  public async createContentFromPublication(
    content: Content,
    publicationId: string,
    workflowId: number,
    contentAudience: ContentAudience,
    isTest: boolean = false,
  ): Promise<CreateDraftContentResponse> {
    const sanitized = this.sanitizeWorkload(content);
    const request = CreateDraftContentRequest.createFromPublication(
      sanitized,
      contentAudience,
      isTest,
      publicationId,
      workflowId,
    );
    const response = await this.svc.post('/contents', this.serializer.serialize(request));
    return this.serializer.deserialize<CreateDraftContentResponse>(
      response.data,
      CreateDraftContentResponse,
    );
  }

  public async getContentWithVersion(contentId: string, versionNumber: number) {
    const response = await this.svc.get(`/contents/${contentId}/version/${versionNumber}`);

    const contentResponse = this.serializer.deserialize<GetDraftContentResponse>(
      response.data,
      GetDraftContentResponse,
    );

    return {
      content: contentResponse.content,
      createdAt: contentResponse.createdAt,
      workflow: contentResponse.workflow,
    };
  }

  @flashbar({ error: 'Failed to fetch all workflows' })
  public async getAllWorkflows(): Promise<ListDraftContentsResponse> {
    const { data: fetchWorkflowsUrl } = await this.svc.get(`workflows`);
    const response = await axios.get(fetchWorkflowsUrl);
    return this.serializer.deserialize<ListDraftContentsResponse>(
      response.data,
      ListDraftContentsResponse,
    );
  }

  @flashbar({ error: 'Failed to fetch all contents' })
  public async getAllContents(): Promise<ListDraftContentsResponse> {
    const response = await this.svc.get('/contents');
    return this.serializer.deserialize<ListDraftContentsResponse>(
      response.data,
      ListDraftContentsResponse,
    );
  }

  @flashbar({ error: 'Failed to fetch all posts' })
  public async getAllPosts(): Promise<ListDraftContentsResponse> {
    const response = await this.svc.get(`contents?contentType=${ContentType.Post}`);
    return this.serializer.deserialize<ListDraftContentsResponse>(
      response.data,
      ListDraftContentsResponse,
    );
  }

  @flashbar({
    error: (e) =>
      e?.response?.status < 500
        ? e?.response?.status === 404
          ? {
              status: e?.response?.status,
              message: 'Could not fetch the content data. It may no longer exist',
            }
          : {
              status: e?.response?.status,
              message:
                'Could not fetch the content data. You are not authorized to read the content',
            }
        : { status: e?.response?.status, message: 'Failed to fetch the content data.' },
  })
  public async getContent(
    contentId: string,
  ): Promise<{ content: Content; createdAt: DateTime; workflow: ContentWorkflow }> {
    const contentResponse = await this.svc.get(`contents/${contentId}`);

    const getContentResponse = this.serializer.deserialize<GetDraftContentResponse>(
      contentResponse.data,
      GetDraftContentResponse,
    );

    return {
      content: getContentResponse.content,
      createdAt: getContentResponse.createdAt,
      workflow: getContentResponse.workflow,
    };
  }

  @flashbar({ error: 'Failed to get content workflow' })
  public async getContentWorkflow(contentId: string): Promise<GetContentWorkflowResponse> {
    const contentWorkflowResponse = await this.svc.get(`workflows/${contentId}`);
    return this.serializer.deserialize<GetContentWorkflowResponse>(
      contentWorkflowResponse.data,
      GetContentWorkflowResponse,
    );
  }

  @flashbar({ error: 'Failed to load content events' })
  public async getContentEvents(
    contentId: string,
    workflowId: number,
  ): Promise<ListWorkflowEventsResponse> {
    const response = await this.svc.get(`/contents/${contentId}/events/${workflowId}`);
    return this.serializer.deserialize<ListWorkflowEventsResponse>(
      response.data,
      ListWorkflowEventsResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated content',
    error: (e) => {
      if (e.response?.data?.message?.includes('link is not valid')) {
        return {
          status: e.response?.status,
          message:
            'A problem has been found with code or ticket URLs. Please go to the code tab and edit your URLs before you will be able to save your content.',
          throwError: false,
          timeout: DEFAULT_FLASHBAR_TIMEOUT * 2, // allow extra time for user to read the message
        };
      } else if (e.response?.data?.message?.includes('Link URL is not valid')) {
        return {
          status: e.response?.status,
          message:
            'A problem has been found with link(s) in your content. Please update your link(s) before you will be able to save your content.',
          throwError: false,
          timeout: DEFAULT_FLASHBAR_TIMEOUT * 2, // allow extra time for user to read the message
        };
      } else {
        return { status: e.response?.status, message: 'Failed to update content.' };
      }
    },
  })
  public async updateContent(contentId: string, content: Content, unlock: boolean = true) {
    const sanitized = this.sanitizeWorkload(content);
    const response = await this.svc.put(`/contents/${contentId}`, {
      content: sanitized,
      contentId,
      unlock,
    });
    return response.data;
  }

  @flashbar({ error: 'Failed to get content workflow history.' })
  public async listWorkflowHistory(contentId: string) {
    const response = await this.svc.get(`/contents/${contentId}/history`);
    return this.serializer.deserialize<ListWorkflowHistoryResponse>(
      response.data,
      ListWorkflowHistoryResponse,
    );
  }

  @flashbar({ error: 'Failed to delete content version' })
  public async deletePublicationVersion(contentId: string, workflowIds: number[]) {
    const qs = queryString.stringify({ workflowIds });
    const response = await this.svc.delete(`/publications/${contentId}/version?${qs}`);
    return this.serializer.deserialize<DeletePublicationVersionResponse>(
      response.data,
      DeletePublicationVersionResponse,
    );
  }

  @flashbar({ error: 'Failed to get content.' })
  public async getPublicationHistory(contentId: string, workflowId: number) {
    const response = await this.svc.get(`/contents/${contentId}/history/${workflowId}`);
    return this.serializer.deserialize<GetWorkflowHistoryResponse>(
      response.data,
      GetWorkflowHistoryResponse,
    );
  }

  @flashbar({ error: 'Failed to get PDF.' })
  public async getPublicationPDF(
    contentId: string,
    workflowId?: number,
  ): Promise<GetPublicationPDFResponse> {
    let response;
    if (workflowId) {
      response = await this.svc.get(`/publication-pdf/${contentId}/${workflowId}`);
    } else {
      response = await this.svc.get(`/publication-pdf/${contentId}`);
    }
    return this.serializer.deserialize<GetPublicationPDFResponse>(
      response.data,
      GetPublicationPDFResponse,
    );
  }

  @flashbar({
    error: [
      { status: 404, message: 'The publication does not exist' },
      { status: 403, message: 'You do not have permission to view the publication' },
    ],
  })
  public async getPublication(contentId: string): Promise<Publication> {
    const publicationResponse = await this.svc.get(`publications/${contentId}`);
    return await this.deserializePublication(contentId, publicationResponse);
  }

  @flashbar({
    error: (e) =>
      e?.response?.status < 500
        ? {
            status: e?.response?.status,
            message: 'Could not find the publication version. The version data may no longer exist',
          }
        : { status: e?.response?.status, message: 'Failed to fetch publication data' },
  })
  public async getPublicationByWorkflow(
    contentId: string,
    workflowId?: number,
    classifier?: string,
  ): Promise<Publication> {
    let publicationResponse;
    if (classifier) {
      publicationResponse = await this.svc.get(
        `publications/${contentId}/${workflowId}?classifier=${classifier}`,
      );
    } else {
      publicationResponse = await this.svc.get(`publications/${contentId}/${workflowId}`);
    }
    return await this.deserializePublication(contentId, publicationResponse);
  }

  @flashbar({ error: 'Failed to update publication tags.' })
  public async updatePublicationTags(
    contentId: string,
    tags: Set<WorkflowTag>,
  ): Promise<UpdateContentTagsResponse> {
    const request = UpdateContentTagsRequest.create(contentId, tags);
    const response = await this.svc.patch(
      `/publications/${contentId}/tags`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateContentTagsResponse>(
      response.data,
      UpdateContentTagsResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated content',
    error: (e) => {
      if (e.response?.data?.message?.includes('link is not valid')) {
        return {
          status: e.response?.status,
          message:
            'A problem has been found with code or ticket URLs. Please go to the code tab and edit your URLs before you will be able to save your content.',
          throwError: false,
          timeout: DEFAULT_FLASHBAR_TIMEOUT * 2, // allow extra time for user to read the message
        };
      } else if (e.response?.data?.message?.includes('Link URL is not valid')) {
        return {
          status: e.response?.status,
          message:
            'A problem has been found with link(s) in your content. Please update your link(s) before you will be able to save your content.',
          throwError: false,
          timeout: DEFAULT_FLASHBAR_TIMEOUT * 2, // allow extra time for user to read the message
        };
      } else {
        return { status: e.response?.status, message: 'Failed to update content.' };
      }
    },
  })
  public async updateFinalizingContent(contentId: string, workflowId: number, content: Content) {
    const sanitized = this.sanitizeWorkload(content);
    const updateRequest = UpdateFinalizingContentRequest.create(contentId, workflowId, sanitized);
    const response = await this.svc.put(
      `/publications/${contentId}/${workflowId}/finalizing`,
      this.serializer.serialize(updateRequest),
    );
    return response.data;
  }

  @flashbar({
    success: 'Successfully reversed finalizing content.',
    error: 'Failed to reverse finalizing content.',
  })
  public async reverseFinalizing(contentId: string, workflowId: number): Promise<any> {
    const response = await this.svc.delete(`/publications/${contentId}/${workflowId}/finalizing`);
    return response.data;
  }

  public async listFinalizing(
    contentId: string,
    workflowId: number,
  ): Promise<ListFinalizingPublicationResponse> {
    const response = await this.svc.get(`/publications/${contentId}/${workflowId}/finalizing`);
    return this.serializer.deserialize<ListFinalizingPublicationResponse>(
      response.data,
      ListFinalizingPublicationResponse,
    );
  }

  public async listPublications() {
    const res = await this.svc.get('publications');
    return this.serializer.deserialize<ListPublicationsResponse>(
      res.data,
      ListPublicationsResponse,
    );
  }

  public async listPublicationsThroughS3() {
    const { data: fetchPublicationsUrl } = await this.svc.get('publications-s3');
    const res = await axios.get(fetchPublicationsUrl);
    return this.serializer.deserialize<ListPublicationsResponse>(
      res.data,
      ListPublicationsResponse,
    );
  }

  public async searchPublications(searchTerm: string): Promise<SearchPublicationsResponse> {
    const qs = queryString.stringify({ searchTerm });
    const res = await this.svc.get(`publications?${qs}`);
    return this.serializer.deserialize<SearchPublicationsResponse>(
      res.data,
      SearchPublicationsResponse,
    );
  }

  public async searchPublicationsByField(
    searchTerm: string,
    field: string,
  ): Promise<SearchPublicationsResponse> {
    const res = await this.svc.get(`publications?searchTerm=${searchTerm}&field=${field}`);
    return this.serializer.deserialize<SearchPublicationsResponse>(
      res.data,
      SearchPublicationsResponse,
    );
  }

  public async searchPublicationSuggestionsByType(
    searchTerm: string,
    contentType: ContentType,
    preview: boolean = true,
  ): Promise<SearchPublicationsResponse> {
    const res = await this.svc.get(
      `publications?searchTerm=${searchTerm}&contentType=${contentType}&preview=${preview}`,
    );
    return this.serializer.deserialize<SearchPublicationsResponse>(
      res.data,
      SearchPublicationsResponse,
    );
  }

  @flashbar({ error: 'Failed to fetch content for user.' })
  public async getContentsForAuthor(userId: string): Promise<ListDraftContentsResponse> {
    const response = await this.svc.get(`contents?owner=${userId}`);
    return this.serializer.deserialize<ListDraftContentsResponse>(
      response.data,
      ListDraftContentsResponse,
    );
  }

  @flashbar({ error: 'Failed to fetch contents to review.' })
  public async getContentsToReview(): Promise<ListDraftContentsResponse> {
    return this.listContentByStates([WorkflowState.IN_REVIEW, WorkflowState.PENDING_REVIEW]);
  }

  @flashbar({ error: 'Failed to fetch internally published contents.' })
  public async listContentsToFinalize(): Promise<ListDraftContentsResponse> {
    return this.listContentByStates([WorkflowState.PUBLISHED, WorkflowState.FINALIZING]);
  }

  @flashbar({ error: 'Failed to fetch contents to publish.' })
  public async getContentsToPublish(): Promise<ListDraftContentsResponse> {
    // Gate PUBLISHER_REVIEW behind UxRedesign: only the redesigned quality-check/bar-raiser flow
    // parks content in PUBLISHER_REVIEW awaiting a publisher, so surface it in the queue only there.
    const states = isFeatureEnabled('UxRedesign')
      ? [WorkflowState.PUBLISHER_REVIEW, WorkflowState.REVIEWED]
      : [WorkflowState.REVIEWED];
    return this.listContentByStates(states);
  }

  @flashbar({ error: 'Failed to fetch finalized content' })
  public async listFinalizedContent(): Promise<ListDraftContentsResponse> {
    return this.listContentByStates([
      WorkflowState.FINALIZED,
      WorkflowState.REVOKED,
      WorkflowState.DISTRIBUTED,
    ]);
  }

  @flashbar({ success: 'Successfully delete content', error: 'Failed to delete content' })
  public async deleteContent(contentId: string) {
    const response = await this.svc.delete(`contents/${contentId}`);
    return response.data;
  }

  @flashbar({
    error:
      'Failed to upload image. Check your permissions and image type. Only .png, .jpg and .jpeg are supported.',
  })
  public async putContentImage(contentId: string, file: File) {
    let extension = '';
    if (file.type) {
      // @ts-expect-error TS2322 - strict migration
      extension = mime.getExtension(file.type);
    }
    const imageId = `${uuid()}.${extension}`;
    const response = await this.svc.put(`/contents/${contentId}/images/${imageId}`, file, {
      headers: { 'Content-Type': file.type },
    });
    response.data = {
      link: `${this.envConfig.mplServiceEndpoint}/contents/${contentId}/images/${imageId}`,
    };
    return response;
  }

  @flashbar({ error: 'Failed to get image. Check if your token is valid.' })
  public async fetchContentImage(srcUrl: string) {
    const imageType = srcUrl?.split('.')?.pop();
    const response = await this.svc.get(srcUrl, {
      responseType: 'arraybuffer',
    });
    const base64String = Buffer.from(response.data, 'binary').toString('base64');
    return `data:image/${imageType};base64,${base64String}`;
  }

  /** @deprecated Use putContentAttachmentWithProgress instead. */
  @flashbar({ error: 'Failed to upload attachment.' })
  public async putContentAttachment(
    contentId: string,
    file: { name: string },
  ): Promise<Attachment> {
    const attachmentId = uuid();
    const options = { headers: { 'Content-Type': 'application/octet-stream' } };
    // @ts-expect-error TS7053 - strict migration
    options.headers['x-amz-tagging'] = `filename=${encodeURIComponent(file.name)}`;
    // @ts-expect-error TS7053 - strict migration
    options.headers['Content-Disposition'] =
      `attachment; filename*=UTF-8''${encodeURIComponent(file.name)}`;

    await this.svc.put(`/contents/${contentId}/attachments/${attachmentId}`, file, options);
    const { attachment } = await this.getAttachmentInfo(contentId, attachmentId);
    return attachment;
  }

  public async putContentAttachmentWithProgress(
    contentId: string,
    file: { name: string },
    onUploadProgress: (percent: number) => void,
  ): Promise<Attachment> {
    const attachmentId = uuid();
    const options: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/octet-stream',
        'x-amz-tagging': `filename=${encodeURIComponent(file.name)}`,
        'Content-Disposition': `attachment; filename*=UTF-8''${encodeURIComponent(file.name)}`,
      },
      onUploadProgress: (event) => {
        if (event.total) onUploadProgress(Math.round((event.loaded / event.total) * 100));
      },
    };

    await this.svc.put(`/contents/${contentId}/attachments/${attachmentId}`, file, options);
    const { attachment } = await this.getAttachmentInfo(contentId, attachmentId);
    return attachment;
  }

  @flashbar({ error: 'Failed to delete attachment.' })
  public async deleteContentAttachment(contentId: string, attachmentId: string) {
    await this.svc.delete(`/contents/${contentId}/attachments/${attachmentId}`);
    const response = await this.svc.get(`/contents/${contentId}/attachments`);
    return response.data;
  }

  public async getAttachmentInfo(
    contentId: string,
    attachmentId: string,
  ): Promise<GetAttachmentInfoResponse> {
    const response = await this.svc.get(`/contents/${contentId}/attachment-info/${attachmentId}`);
    return this.serializer.deserialize<GetAttachmentInfoResponse>(
      response.data,
      GetAttachmentInfoResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated draft metadata.',
    error: 'Failed to update draft metadata.',
  })
  public async updateDraftMetadata(
    contentId: string,
    templateMetadata: any,
  ): Promise<UpdateMetadataResponse> {
    const sanitized = this.sanitizeTemplateMetadata(templateMetadata);
    const request = UpdateMetadataRequest.create(contentId, sanitized);
    const response = await this.svc.put(
      `/contents/${contentId}/metadata`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateMetadataResponse>(
      response.data,
      UpdateMetadataResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated publication metadata.',
    error: 'Failed to update publication metadata.',
  })
  public async updatePublicationMetadata(
    contentId: string,
    templateMetadata: any,
  ): Promise<UpdateMetadataResponse> {
    const sanitized = this.sanitizeTemplateMetadata(templateMetadata);
    const request = UpdateMetadataRequest.create(contentId, sanitized);
    const response = await this.svc.put(
      `/publications/${contentId}/metadata`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateMetadataResponse>(
      response.data,
      UpdateMetadataResponse,
    );
  }

  public async getDiagramGuidelinesDeck(): Promise<GetDiagramGuidelinesDeckResponse> {
    const response = await this.svc.get('/diagram-guidelines-deck');
    return this.serializer.deserialize<GetDiagramGuidelinesDeckResponse>(
      response.data,
      GetDiagramGuidelinesDeckResponse,
    );
  }

  /**** Content Suggestions */

  @flashbar({ error: 'Failed to retrieve content requests.' })
  public async listContentRequests() {
    const response = await this.svc.get('/content-requests');
    return this.serializer.deserialize<ListContentRequestsResponse>(
      response.data,
      ListContentRequestsResponse,
    );
  }

  @flashbar({ error: 'Failed to retrieve content request summary.' })
  public async listContentRequestSummary() {
    const response = await this.svc.get('/content-requests/summary');
    return this.serializer.deserialize<ListContentRequestsResponse>(
      response.data,
      ListContentRequestsResponse,
    );
  }

  @flashbar({ error: 'Failed to retrieve content requests for user.' })
  public async listContentRequestsForAuthenticatedUser(userId: string) {
    const response = await this.svc.get(`/content-requests?userId=${userId}`);
    return this.serializer.deserialize<ListContentRequestsResponse>(
      response.data,
      ListContentRequestsResponse,
    );
  }

  @flashbar({ error: 'Failed to retrieve content requests for assignee.' })
  public async listContentRequestsForAssignee(assigneeId: string) {
    const response = await this.svc.get(`/content-requests?assigneeId=${assigneeId}`);
    return this.serializer.deserialize<ListContentRequestsResponse>(
      response.data,
      ListContentRequestsResponse,
    );
  }

  @flashbar({ error: 'Failed to retrieve content request.' })
  public async getContentRequestById(contentRequestId: string) {
    const response = await this.svc.get(`content-requests/${contentRequestId}`);
    return this.serializer.deserialize<GetContentRequestResponse>(
      response.data,
      GetContentRequestResponse,
    );
  }

  @flashbar({ error: 'Failed to update Content Request.' })
  public async updateContentRequests(
    contentRequestId: string,
    state: ContentRequestState,
    updateConfig: ContentRequestUpdateConfig,
    changedReference?: any,
  ): Promise<UpdateContentRequestResponse> {
    const request = UpdateContentRequestRequest.create(contentRequestId, state, updateConfig, {
      referenceCompleted: changedReference && changedReference.referenceCompleted,
      referenceDuplicated: changedReference && changedReference.referenceDuplicated,
    });
    const response = await this.svc.patch(
      `/content-requests/${contentRequestId}`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateContentRequestResponse>(
      response.data,
      UpdateContentRequestResponse,
    );
  }

  @flashbar({
    success: 'Successfully submitted content suggestion',
    error: 'Failed to create Content Request',
  })
  public async createContentRequest(
    contentType: ContentType,
    requestData: any,
    assigneeId?: string,
  ) {
    try {
      await this.svc.post('/tickets', { requestData, eventType: 'request-content' });
    } catch (e) {
      localLog.debug('Failed to create ticket for new Content Request.');
    }
    const contentRequestData = this.serializer.deserialize<ContentRequestData>(
      requestData,
      ContentRequestData,
    );
    // @ts-expect-error TS2345 - strict migration
    const request = CreateContentRequestRequest.create(contentType, contentRequestData, assigneeId);
    const response = await this.svc.post('/content-requests', this.serializer.serialize(request));
    return this.serializer.deserialize<CreateContentRequestResponse>(
      response.data,
      CreateContentRequestResponse,
    );
  }

  @flashbar({
    success: 'Successfully deleted content suggestion',
    error: 'Failed to delete Content Request',
  })
  public async deleteContentRequest(requestId: string) {
    const request = DeleteContentRequestRequest.create(requestId);
    const response = this.svc.delete(
      `/content-requests/${requestId}`,
      this.serializer.serialize(request),
    );
    return response;
  }

  /**** Content quality ****/

  @flashbar({ error: 'Failed to get questionnaire.' })
  public async getQuestionnaireQuestions(
    contentType: ContentType,
  ): Promise<GetContentQualityQuestionsResponse> {
    const getRequest = GetContentQualityQuestionsRequest.create(contentType);
    const request = this.serializer.serialize(getRequest);
    const response = await this.svc.get(`/quality-questions/${contentType}`, request);
    return this.serializer.deserialize<GetContentQualityQuestionsResponse>(
      response.data,
      GetContentQualityQuestionsResponse,
    );
  }

  @flashbar({
    success: 'Successfully submitted quality evaluation for content.',
    error: (e) =>
      e?.response?.status < 500
        ? {
            status: e?.response?.status,
            message:
              'Failed to create evaluation. Another user might have already evaluated this content.',
          }
        : { status: e?.response?.status, message: 'Failed to create evaluation.' },
  })
  public async createContentQualityEvaluation(
    contentId: string,
    workflowId: number,
    responses: QuestionnaireResponses,
    score: number,
  ): Promise<CreateContentQualityEvaluationResponse> {
    const createRequest = CreateContentQualityEvaluationRequest.create(
      contentId,
      workflowId,
      responses,
      score,
    );
    const request = this.serializer.serialize(createRequest);
    const response = await this.svc.post('/quality-evaluation', request);
    return this.serializer.deserialize<CreateContentQualityEvaluationResponse>(
      response.data,
      CreateContentQualityEvaluationResponse,
    );
  }

  public async getLastContentQualityEvaluation(
    contentId: string,
  ): Promise<GetContentQualityEvaluationResponse> {
    const getRequest = GetContentQualityEvaluationRequest.create(contentId);
    const request = this.serializer.serialize(getRequest);
    const response = await this.svc.get(`/quality-evaluation/${contentId}`, request);
    return this.serializer.deserialize<GetContentQualityEvaluationResponse>(
      response.data,
      GetContentQualityEvaluationResponse,
    );
  }

  /*************************************************** User APIs ****************************************************************/
  @flashbar({ error: 'Failed to retrieve user profile' })
  // @ts-expect-error TS2366 - strict migration
  public async getUserProfile(userId: string): Promise<GetUserProfileResponse> {
    const response = await this.svc.get(`users?userIds=${userId}`);
    if (response.data) {
      return this.serializer.deserialize(response.data[0], GetUserProfileResponse);
    }
  }

  @flashbar({ error: 'Failed to retrieve user profile' })
  public async getUserProfiles(): Promise<GetUserProfileResponse[]> {
    let response = await this.svc.get(`users`);
    if (typeof response.data === 'string') {
      response = await axios.get(response.data);
    }
    return this.serializer.deserializeArray(response.data, GetUserProfileResponse);
  }

  @flashbar({ error: 'Failed to retrieve user profile for authenticated user account.' })
  public async getCurrentUserProfile(): Promise<GetUserProfileResponse> {
    const response = await this.svc.get(`/users/current`);
    return this.serializer.deserialize<GetUserProfileResponse>(
      response.data,
      GetUserProfileResponse,
    );
  }

  @flashbar({ success: 'Successfully update user roles', error: 'Failed to update user roles' })
  public async updateUserRoles(
    userId: string,
    roles: Set<UserRoles>,
    contentRoles: ContentUserRoleDefinition[],
  ) {
    const requestData = this.serializer.serialize(
      new UpdateUserRoleRequest({ userId, roles, contentRoles }),
    );
    const response = await this.svc.patch(`/users/${userId}`, requestData);
    return response.data;
  }

  public async getTechWriterProfiles(controller?: AbortController) {
    let opts: AxiosRequestConfig;
    if (controller) {
      opts = { signal: controller.signal };
    }
    // @ts-expect-error TS2454 - strict migration
    const response = await this.svc.get(`/users/tech-writer`, opts);
    return this.serializer.deserialize<GetUserProfilesResponse>(
      response.data,
      GetUserProfilesResponse,
    );
  }

  // @ts-expect-error TS7006 - strict migration
  public async getBarRaiserProfilesByTechDomain(techDomain, controller?: AbortController) {
    let opts: AxiosRequestConfig;
    if (controller) {
      opts = { signal: controller.signal };
    }
    // @ts-expect-error TS2454 - strict migration
    const response = await this.svc.get(`/users/bar-raiser/${techDomain}`, opts);
    return this.serializer.deserialize<GetUserProfilesResponse>(
      response.data,
      GetUserProfilesResponse,
    );
  }

  public async searchUsers(
    searchTerm: string,
  ): Promise<Array<{ userId: string; name: string; type: string }>> {
    const queryParams = queryString.stringify({ searchTerm });
    const response = await this.svc.get(`/users/search?${queryParams}`);

    // @ts-expect-error TS7006 - strict migration
    return response.data?.userProfiles?.map((up) => ({
      userId: up.userId,
      name: `${up.firstName} ${up.lastName}`,
      type: UserType.AWS,
    }));
  }

  public async getBarRaiserLeaderboard(
    techDomain: TechDomain,
  ): Promise<GetBarRaiserLeaderboardResponse> {
    const queryParams = { techDomain };
    const qs = queryString.stringify(queryParams);
    const response = await this.svc.get(`/users/top-bar-raisers?${qs}`);
    return this.serializer.deserialize<GetBarRaiserLeaderboardResponse>(
      response.data,
      GetBarRaiserLeaderboardResponse,
    );
  }

  /****** Comments */

  public async getCommentsToPublish() {
    const response = await this.svc.get('/publication-comments-to-review');
    return this.serializer.deserialize<ListPublicationCommentsToReviewResponse>(
      response.data,
      ListPublicationCommentsToReviewResponse,
    );
  }

  @flashbar({ error: 'Failed to load comments.' })
  public async getCommentsForPublication(contentId: string) {
    const response = await this.svc.get(`/publications-comments/${contentId}`);
    return this.serializer.deserialize<ListPublicationCommentsResponse>(
      response.data,
      ListPublicationCommentsResponse,
    );
  }

  @flashbar({ success: 'Successfully created comment', error: 'Failed to create comment.' })
  public async createComment(contentId: string, comment: string) {
    const contentComment = {
      comment,
    };
    const response = await this.svc.post(`/publications-comments/${contentId}`, contentComment);
    return this.serializer.deserialize<CreatePublicationCommentResponse>(
      response.data,
      CreatePublicationCommentResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated comment state.',
    error: 'Failed to update comment state.',
  })
  public async updateCommentState(comment: PublicationComment, newState: PublicationCommentState) {
    const { contentId, commentId } = comment;
    const response = await this.svc.patch(`/publications-comments/${contentId}/${commentId}`, {
      newState,
    });
    return this.serializer.deserialize<CreatePublicationCommentResponse>(
      response.data,
      CreatePublicationCommentResponse,
    );
  }

  /****** Comment Threads */
  public async listCommentThreads(contentId: string, workflowId: number, sectionId?: string) {
    const qs = queryString.stringify({ sectionId });
    const request = this.serializer.serialize(ListThreadsRequest.create(contentId, workflowId));
    const response = await this.svc.get(
      `/comments/threads/${contentId}/${workflowId}?${qs}`,
      request,
    );
    return this.serializer.deserialize<ListThreadsResponse>(response.data, ListThreadsResponse);
  }

  @flashbar({ error: 'Failed to list replied for thread.' })
  public async listRepliesForThread(threadId: string) {
    const request = this.serializer.serialize(ListThreadRepliesRequest.create(threadId));
    const response = await this.svc.get(`/comments/replies/${threadId}`, request);
    return this.serializer.deserialize<ListThreadRepliesResponse>(
      response.data,
      ListThreadRepliesResponse,
    );
  }

  @flashbar({ error: 'Failed to create comment thread.' })
  public async createCommentThread(
    contentId: string,
    workflowId: number,
    sectionId: string,
    commentData: string,
  ) {
    const request = this.serializer.serialize(
      CreateContentThreadRequest.create(contentId, workflowId, sectionId, commentData),
    );
    const response = await this.svc.post(
      `/comments/threads/${contentId}/${workflowId}/${sectionId}`,
      request,
    );
    return this.serializer.deserialize<CreateContentThreadResponse>(
      response.data,
      CreateContentThreadResponse,
    );
  }

  @flashbar({ error: 'Failed to create reply comment.' })
  public async createCommentReply(threadId: string, commentData: string) {
    const request = this.serializer.serialize(
      CreateReplyCommentRequest.create(threadId, commentData),
    );
    const response = await this.svc.post(`/comments/replies/${threadId}`, request);
    return this.serializer.deserialize<CreateReplyCommentResponse>(
      response.data,
      CreateReplyCommentResponse,
    );
  }

  public async updateComment(
    commentId: string,
    updateAttributes: { state?: UserCommentState; commentData?: string },
  ) {
    const response = await this.svc.put(`/comments/${commentId}`, {
      commentId,
      ...updateAttributes,
    });
    return this.serializer.deserialize<UpdateUserCommentResponse>(
      response.data,
      UpdateUserCommentResponse,
    );
  }

  @flashbar({ error: 'Failed to delete comment.' })
  public async deleteComment(commentId: string) {
    const request = this.serializer.serialize(DeleteUserCommentRequest.create(commentId));
    const response = await this.svc.delete(`/comments/${commentId}`, request);
    return this.serializer.deserialize<DeleteUserCommentResponse>(
      response.data,
      DeleteUserCommentResponse,
    );
  }

  @flashbar({ error: 'Failed to update comment sections.' })
  public async updateCommentSections(
    contentId: string,
    workflowId: number,
    commentConversions: CommentConversion[],
  ) {
    const request = this.serializer.serialize(
      UpdateCommentSectionsRequest.create(contentId, workflowId, commentConversions),
    );
    const response = await this.svc.post(
      `/comments/${contentId}/${workflowId}/conversion`,
      request,
    );
    return this.serializer.deserialize<UpdateCommentSectionsResponse>(
      response.data,
      UpdateCommentSectionsResponse,
    );
  }

  public async getInlineEdits(contentId: string): Promise<GetInlineEditsResponse> {
    const response = await this.svc.get(`/contents/${contentId}/inline-edits`);
    return this.serializer.deserialize<GetInlineEditsResponse>(
      response.data,
      GetInlineEditsResponse,
    );
  }

  public async resolveInlineEdit(
    contentId: string,
    editId: string,
    resolution: InlineEditResolution,
  ): Promise<ResolveInlineEditResponse> {
    const { data } = await this.svc.put<ResolveInlineEditResponse>(
      `/contents/${contentId}/inline-edits/${editId}/resolve`,
      { resolution },
    );
    return data;
  }

  public async bulkResolveInlineEdits(
    contentId: string,
    page?: string,
  ): Promise<BulkResolveInlineEditsResponse> {
    const { data } = await this.svc.put<BulkResolveInlineEditsResponse>(
      `/contents/${contentId}/inline-edits/resolve-all`,
      page ? { page } : {},
    );
    return data;
  }

  public async getDuplicationResults(
    contentId: string,
    scanId: string,
  ): Promise<GetDuplicationResultsResponse> {
    const { data } = await this.svc.get<GetDuplicationResultsResponse>(
      `/contents/${contentId}/duplication-results/${scanId}`,
    );
    return data;
  }

  @flashbar({ error: 'Failed to list inline comments.' })
  public async listInlineComments(contentId: string, workflowId: number) {
    return this.fetchInlineComments(contentId, workflowId);
  }

  /**
   * Same fetch as {@link listInlineComments} but without the global flashbar
   * toast, so callers that surface the failure themselves don't double-report it.
   *
   * @deprecated Transitional: kept until MplServiceClientV2 is fully deployed.
   */
  public async listInlineCommentsWithoutFlashbar(contentId: string, workflowId: number) {
    return this.fetchInlineComments(contentId, workflowId);
  }

  private async fetchInlineComments(contentId: string, workflowId: number) {
    const request = this.serializer.serialize(
      ListInlineCommentRequest.create(contentId, workflowId),
    );
    const response = await this.svc.get(`/inline-comment/${contentId}/${workflowId}`, request);
    return this.serializer.deserialize<ListInlineCommentResponse>(
      response.data,
      ListInlineCommentResponse,
    );
  }

  @flashbar({ error: 'Failed to update inline comments.' })
  public async updateInlineComments(
    contentId: string,
    workflowId: number,
    updateAttributes: UpdateInlineCommentsAttributes[],
  ) {
    const response = await this.svc.patch(`/inline-comment/${contentId}`, {
      contentId,
      workflowId,
      updateInlineCommentsConfig: updateAttributes,
    });
    return this.serializer.deserialize<UpdateInlineCommentsResponse>(
      response.data,
      UpdateInlineCommentsResponse,
    );
  }

  @flashbar({ error: 'Failed to delete inline comment.' })
  public async deleteInlineComment(commentId: string) {
    const request = this.serializer.serialize(DeleteInlineCommentRequest.create(commentId));
    const response = await this.svc.delete(`/inline-comment/${commentId}`, request);
    return this.serializer.deserialize<DeleteInlineCommentResponse>(
      response.data,
      DeleteInlineCommentResponse,
    );
  }

  @flashbar({
    error: (e) =>
      e?.response?.status < 500
        ? {
            status: 500,
            message:
              'Failed to create inline comment. Make sure input is valid and content is not being edited.',
          }
        : { status: e?.response?.status, message: 'Failed to create inline comment.' },
  })
  public async createInlineComment(
    path: string[],
    contentId: string,
    workflowId: number,
    commentType: UserCommentType,
    commentData: string,
    textData: string,
    threadId: string,
    startOffset: number,
    endOffset: number,
  ) {
    const request = this.serializer.serialize(
      CreateInlineCommentRequest.create(
        path,
        contentId,
        workflowId,
        commentType,
        commentData,
        textData,
        threadId,
        startOffset,
        endOffset,
      ),
    );
    const response = await this.svc.post(`/inline-comment/${contentId}`, request);
    return this.serializer.deserialize<CreateInlineCommentResponse>(
      response.data,
      CreateInlineCommentResponse,
    );
  }

  /**** Shared Resources ******/
  public async listSharedContentsForUser(userId: string) {
    const response = await this.svc.get(`/shared-contents?userId=${userId}`);
    return this.serializer.deserialize<ListSharedContentsResponse>(
      response.data,
      ListSharedContentsResponse,
    );
  }

  public async listAllSharedContents() {
    const response = await this.svc.get(`/shared-contents/all`);
    return response.data;
  }

  @flashbar({
    success: 'Successfully shared content to user',
    error: (e) =>
      e?.response?.status === 403
        ? {
            status: e?.response?.status,
            message: 'You do not have permission to share the content or sharing users are invalid',
          }
        : { status: e?.response?.status, message: 'Failed to share content' },
  })
  public async shareContents(contentIds: string[], userIds: string[]) {
    const request = this.serializer.serialize(ShareContentsRequest.create(contentIds, userIds));
    const response = await this.svc.post(`/shared-contents`, request);
    return this.serializer.deserialize<ShareContentsResponse>(response.data, ShareContentsResponse);
  }

  @flashbar({ error: 'Failed to unshare content.' })
  public async unShareContents(contentIds: string[], userIds: string[]) {
    return await Promise.all(
      contentIds.map((contentId) => {
        return Promise.all(
          userIds.map((userId) => this.svc.delete(`/shared-contents/${contentId}/${userId}`)),
        );
      }),
    );
  }

  public async listContentSharedWith(contentId: string): Promise<ListContentAccessResponse> {
    const response = await this.svc.get(`/shared-contents/${contentId}/sharedWith`);
    return this.serializer.deserialize<ListContentAccessResponse>(
      response.data,
      ListContentAccessResponse,
    );
  }

  @flashbar({ error: 'Failed to add peer reviewers.' })
  public async addContentReviewers(contentIds: string[], userIds: string[]) {
    const request = this.serializer.serialize(
      UpdateContentReviewersRequest.create(contentIds, userIds),
    );
    const response = await this.svc.put(`/review-requests`, request);
    return this.serializer.deserialize<UpdateContentReviewersResponse>(
      response.data,
      ShareContentsResponse,
    );
  }

  @flashbar({ error: 'Failed to remove peer reviewers.' })
  public async removeContentReviewers(contentIds: string[], userIds: string[]) {
    return await Promise.all(
      contentIds.map((contentId) => {
        return Promise.all(
          userIds.map((userId) => this.svc.delete(`/review-requests/${contentId}/${userId}`)),
        );
      }),
    );
  }

  public async listContentReviewers(contentId: string) {
    const response = await this.svc.get(`/review-requests/${contentId}/reviewers`);
    return this.serializer.deserialize<ListContentReviewersResponse>(
      response.data,
      ListContentReviewersResponse,
    );
  }

  public async listContentsAssignedToReview(userId: string) {
    const response = await this.svc.get(`/review-requests?userId=${userId}`);
    return this.serializer.deserialize<ListContentsToReviewResponse>(
      response.data,
      ListContentsToReviewResponse,
    );
  }

  /**** APGL User Profiles ******/
  public async listContentsReviewedByUser(userId: string) {
    const response = await this.svc.get(`/apgl-user-profiles/${userId}/reviewed-content`);
    return this.serializer.deserialize<ListContentsReviewedByUserResponse>(
      response.data,
      ListContentsReviewedByUserResponse,
    );
  }

  @flashbar({
    success: 'Successfully created APGL user profile.',
    error: 'Failed to create APGL user profile.',
  })
  public async createAPGLUserProfile(description: string, attributes: APGLUserProfileAttributes) {
    const request = CreateAPGLUserProfileRequest.create(description, attributes);
    const response = await this.svc.post('apgl-user-profiles', this.serializer.serialize(request));
    return this.serializer.deserialize<CreateAPGLUserProfileResponse>(
      response.data,
      CreateAPGLUserProfileResponse,
    );
  }

  public async listAPGLUserProfiles(
    domainFilter: { techDomains?: TechDomain[]; awsServices?: AWSService[] } = {},
  ) {
    const qs = queryString.stringify({ ...domainFilter });
    const response = await this.svc.get(`apgl-user-profiles?${qs}`);
    return this.serializer.deserialize<ListAPGLUserProfilesResponse>(
      response.data,
      ListAPGLUserProfilesResponse,
    );
  }

  @flashbar({ error: 'Failed to fetch APGL user profile.' })
  public async getAPGLUserProfile(userId: string, attribute?: APGLUserProfileRecordSubType) {
    let response;
    if (attribute) {
      response = await this.svc.get(`/apgl-user-profiles/${userId}?domain=${attribute}`);
    } else {
      response = await this.svc.get(`/apgl-user-profiles/${userId}`);
    }
    return this.serializer.deserialize<GetAPGLUserProfileResponse>(
      response.data,
      GetAPGLUserProfileResponse,
    );
  }

  @flashbar({
    success: 'Successfully updated APGL user profile.',
    error: 'Failed to update APGL user profile.',
  })
  public async updateAPGLUserProfile(
    userId: string,
    description: string,
    attributes: APGLUserProfileAttributes,
  ) {
    const request = UpdateAPGLUserProfileRequest.create(description, attributes);
    const response = await this.svc.patch(
      `/apgl-user-profiles/${userId}`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdateAPGLUserProfileResponse>(
      response.data,
      UpdateAPGLUserProfileResponse,
    );
  }

  public async sendPublicationFeedback(
    contentId: string,
    issueType: PublicationIssueType,
    improvementFeedback: string,
    intendedAction: string,
    comment?: string,
    isBarRaiserFeedback?: boolean,
  ) {
    const feedbackData = PublicationFeedbackData.create(
      issueType,
      improvementFeedback,
      intendedAction,
      comment,
    );
    const request = this.serializer.serialize(
      CreatePublicationFeedbackRequest.create(contentId, feedbackData, isBarRaiserFeedback),
    );
    const response = await this.svc.post(`/publication-feedback/${contentId}`, request);
    return response;
  }

  @flashbar({ error: 'Failed to list feedbacks for publications.' })
  public async listPublicationFeedbacks(contentId: string): Promise<any> {
    const response = await this.svc.get(`/publication-feedback/${contentId}`);
    return this.serializer.deserialize<ListPublicationFeedbacksResponse>(
      response.data,
      ListPublicationFeedbacksResponse,
    );
  }

  @flashbar({ error: 'Failed to update publication feedback' })
  public async updatePublicationFeedback(
    contentId: string,
    feedbackId: string,
    feedbackConfig: { state?: PublicationFeedbackState; notes?: string; comment?: string } = {},
  ): Promise<any> {
    const request = UpdatePublicationFeedbackRequest.create(contentId, feedbackId, feedbackConfig);
    const response = await this.svc.patch(
      `/publication-feedback/${contentId}/${feedbackId}`,
      this.serializer.serialize(request),
    );
    return this.serializer.deserialize<UpdatePublicationFeedbackResponse>(
      response.data,
      UpdatePublicationFeedbackResponse,
    );
  }

  public async postContentWorkingCopy(
    contentId: string,
    workingCopy: ContentWorkingCopy,
    createdAt: DateTime,
    wcKey: WorkingCopyKey,
  ): Promise<CreateContentWorkingCopyResponse> {
    const sanitizedCopy = workingCopy.content
      ? { ...workingCopy, content: this.sanitizeWorkload(workingCopy.content) }
      : workingCopy;
    const request = this.serializer.serialize(
      CreateContentWorkingCopyRequest.create(
        contentId,
        sanitizedCopy as ContentWorkingCopy,
        createdAt,
        wcKey,
      ),
    );
    const response = await this.svc.post(`/contents/${contentId}/working-copies`, request);
    return this.serializer.deserialize<CreateContentWorkingCopyResponse>(
      response.data,
      CreateContentWorkingCopyResponse,
    );
  }

  public async listContentWorkingCopies(
    contentId: string,
    workingCopyKey: WorkingCopyKey,
    limit: number,
  ): Promise<ListContentWorkingCopyResponse> {
    const qs = queryString.stringify({ workingCopyKey, limit });
    const response = await this.svc.get(`/contents/${contentId}/working-copies?${qs}`);
    return this.serializer.deserialize<ListContentWorkingCopyResponse>(
      response.data,
      ListContentWorkingCopyResponse,
    );
  }

  public async getContentWorkingCopy(
    contentId: string,
    workingCopyKey: WorkingCopyKey,
    digest: string,
  ): Promise<GetContentWorkingCopyResponse> {
    const response = await this.svc.get(
      `/contents/${contentId}/working-copies/${workingCopyKey}/${digest}`,
    );
    return this.serializer.deserialize<GetContentWorkingCopyResponse>(
      response.data,
      GetContentWorkingCopyResponse,
    );
  }

  public async deleteContentWorkingCopies(contentId: string, workingCopyKey: WorkingCopyKey) {
    await this.svc.delete(`/contents/${contentId}/working-copies/${workingCopyKey}`);
  }

  public async getContentTemplate(templateId: string): Promise<GetContentTemplateResponse> {
    const response = await this.svc.get(`/content-templates/${templateId}`);
    return this.serializer.deserialize<GetContentTemplateResponse>(
      response.data,
      GetContentTemplateResponse,
    );
  }

  /**** Content Engagements ****/
  public async createContentEngagements(
    contentId: string,
    userId: string,
    contentEngagements: ContentEngagement[],
    engagementSource: EngagementSource,
  ) {
    const request = this.serializer.serialize(
      CreateContentEngagementRequest.create(
        contentId,
        userId,
        contentEngagements,
        engagementSource,
      ),
    );
    const response = await this.svc.post(`/content-engagements/${contentId}`, request);
    return this.serializer.deserialize<CreateContentEngagementResponse>(
      response.data,
      CreateContentEngagementResponse,
    );
  }

  public async updateContentEngagements(
    contentId: string,
    userId: string,
    contentEngagements: ContentEngagement[],
    engagementSource: EngagementSource,
  ) {
    const updateRequest = UpdateContentEngagementRequest.create(
      contentId,
      contentEngagements,
      engagementSource,
    );
    const request = this.serializer.serialize(updateRequest);
    const response = await this.svc.put(`/content-engagements/${contentId}/${userId}`, request);
    return this.serializer.deserialize<UpdateContentEngagementResponse>(
      response.data,
      UpdateContentEngagementResponse,
    );
  }

  public async getContentEngagements(
    contentId: string,
    userId: string,
  ): Promise<GetContentEngagementResponse> {
    const response = await this.svc.get(`/content-engagements/${contentId}/${userId}`);
    return this.serializer.deserialize<GetContentEngagementResponse>(
      response.data,
      GetContentEngagementResponse,
    );
  }

  public async listContentEngagements(contentId: string): Promise<ListContentEngagementResponse> {
    const response = await this.svc.get(`/content-engagements/${contentId}`);
    return this.serializer.deserialize<ListContentEngagementResponse>(
      response.data,
      ListContentEngagementResponse,
    );
  }

  public async getContentEngagementStats(
    contentId: string,
    userId: string,
  ): Promise<GetContentEngagementStatsResponse> {
    const response = await this.svc.get(`/content-engagement-stats/${contentId}`);
    return this.serializer.deserialize<GetContentEngagementStatsResponse>(
      response.data,
      GetContentEngagementStatsResponse,
    );
  }

  public async listEnabledFeatures() {
    const response = await this.svc.get('/features');
    return this.serializer.deserialize<ListEnabledFeaturesResponse>(
      response.data,
      ListEnabledFeaturesResponse,
    );
  }

  /*** Content Notes ***/
  public async createContentNote(
    contentId: string,
    note: string,
  ): Promise<CreateContentNoteResponse> {
    const request = this.serializer.serialize(CreateContentNoteRequest.create(contentId, note));
    const response = await this.svc.post(`/contents/${contentId}/notes`, request);
    return this.serializer.deserialize<CreateContentNoteResponse>(
      response.data,
      CreateContentNoteResponse,
    );
  }

  public async updateContentNote(
    contentId: string,
    noteId: string,
    note: string,
  ): Promise<UpdateContentNoteResponse> {
    const request = this.serializer.serialize(
      UpdateContentNoteRequest.create(contentId, noteId, note),
    );
    const response = await this.svc.patch(`/contents/${contentId}/notes/${noteId}`, request);
    return this.serializer.deserialize<UpdateContentNoteResponse>(
      response.data,
      UpdateContentNoteResponse,
    );
  }

  public async deleteContentNote(
    contentId: string,
    noteId: string,
  ): Promise<DeleteContentNoteResponse> {
    const response = await this.svc.delete(`/contents/${contentId}/notes/${noteId}`);
    return this.serializer.deserialize<DeleteContentNoteResponse>(
      response.data,
      DeleteContentNoteResponse,
    );
  }

  public async getContentNoteStats(): Promise<GetContentNoteStatsResponse> {
    const response = await this.svc.get(`/contents/notes/stats`);
    return this.serializer.deserialize<GetContentNoteStatsResponse>(
      response.data,
      GetContentNoteStatsResponse,
    );
  }

  public async listContentNotes(contentId: string): Promise<ListContentNotesResponse> {
    const response = await this.svc.get(`/contents/${contentId}/notes`);
    return this.serializer.deserialize<ListContentNotesResponse>(
      response.data,
      ListContentNotesResponse,
    );
  }

  /*** Content Collections ***/
  public async createCollection(
    title: string,
    description: string,
    audience: CollectionAudience,
  ): Promise<CreateCollectionResponse> {
    const request = CreateCollectionRequest.create(title, description, audience);
    const response = await this.svc.post(`/collections`, request);
    return this.serializer.deserialize<CreateCollectionResponse>(
      response.data,
      CreateCollectionResponse,
    );
  }

  @flashbar({
    error: [
      { status: 404, message: 'The collection does not exist' },
      { status: 403, message: 'You do not have permission to view the collection' },
    ],
  })
  public async getCollection(collectionId: string): Promise<GetCollectionResponse> {
    const response = await this.svc.get(`/collections/${collectionId}`);
    return this.serializer.deserialize<GetCollectionResponse>(response.data, GetCollectionResponse);
  }

  public async listCollectionByUser(): Promise<ListCollectionsResponse> {
    const response = await this.svc.get(`/collections`);
    return this.serializer.deserialize<ListCollectionsResponse>(
      response.data,
      ListCollectionsResponse,
    );
  }

  public async publishCollection(collection: Collection) {
    const request = PublishCollectionRequest.create(collection);
    const response = await this.svc.post('/publish-collection', request);
    return this.serializer.deserialize<PublishCollectionResponse>(
      response.data,
      PublishCollectionResponse,
    );
  }

  public async listPublicCollections(): Promise<ListPublicCollectionResponse> {
    const response = await this.svc.get('/public-collections');
    return this.serializer.deserialize<ListPublicCollectionResponse>(
      response.data,
      ListPublicCollectionResponse,
    );
  }

  public async editCollection(collection: Collection) {
    const { collectionId, title, description, audience, epics, owners } = collection;
    // @ts-expect-error TS18048 - strict migration
    const ownerIds = owners.map((owner) => owner.userId);
    const request = EditCollectionRequest.create(
      collectionId,
      title,
      description,
      audience,
      // @ts-expect-error TS2345 - strict migration
      epics,
      ownerIds,
    );
    const response = await this.svc.put(`/collection/${collectionId}`, request);
    return this.serializer.deserialize<EditCollectionResponse>(
      response.data,
      EditCollectionResponse,
    );
  }

  public async createCollectionEvent(type: CollectionEventType, collectionId: string) {
    const request = CreateCollectionEventRequest.create(collectionId, type);
    const response = await this.svc.put(`/collection/event/${collectionId}`, request);
    return this.serializer.deserialize<CreateCollectionEventResponse>(
      response.data,
      CreateCollectionEventResponse,
    );
  }

  public async deleteCollection(collectionId: string) {
    const response = await this.svc.delete(`/collections/${collectionId}`);
    return this.serializer.deserialize<DeleteCollectionResponse>(
      response.data,
      DeleteCollectionResponse,
    );
  }

  public async addCollectionOwner(collectionId: string, userId: string) {
    const response = await this.svc.put(`/collection/share/${collectionId}`, { userId });
    return this.serializer.deserialize<AddCollectionOwnerResponse>(
      response.data,
      AddCollectionOwnerResponse,
    );
  }

  public async removeCollectionOwner(collectionId: string, userId: string) {
    const response = await this.svc.delete(`/collection/share/${collectionId}/${userId}`);
    return this.serializer.deserialize<RemoveCollectionOwnerResponse>(
      response.data,
      RemoveCollectionOwnerResponse,
    );
  }

  public async listAllCollections() {
    const response = await this.svc.get('/all-collections');
    return this.serializer.deserialize<ListCollectionsResponse>(
      response.data,
      ListCollectionsResponse,
    );
  }

  public async unpublishCollection(collectionId: string) {
    const response = await this.svc.delete(`/unpublish-collection/${collectionId}`);
    return this.serializer.deserialize<UnpublishCollectionResponse>(
      response.data,
      UnpublishCollectionResponse,
    );
  }

  public async queryContent(
    queryConditions: DraftContentQueryConditions[],
    queryConditionsOperation: 'and' | 'or',
    filterCriteria?: BarRaiserFilter,
  ) {
    const requestData = this.serializer.serialize(
      new QueryDraftContentsRequest({ queryConditions, queryConditionsOperation, filterCriteria }),
    );
    let response = await this.svc.post('/contents-query', requestData);
    if (!response.data.workflows) {
      response = await axios.get(response.data);
    }
    const responseData = this.serializer.deserialize<ListDraftContentsResponse>(
      response.data,
      ListDraftContentsResponse,
    );
    return responseData;
  }

  public async submitFeedback(
    submitFeedbackRequest: SubmitFeedbackRequest,
  ): Promise<FeedbackItemStatistics> {
    const response = await this.svc.put(
      '/feedback',
      this.serializer.serialize(submitFeedbackRequest),
    );
    const responseData = this.serializer.deserialize<SubmitDeleteFeedbackResponse>(
      response.data,
      SubmitDeleteFeedbackResponse,
    );
    return responseData.feedbackItemStatistics;
  }

  public async deleteFeedback(
    deleteFeedbackRequest: DeleteFeedbackRequest,
  ): Promise<FeedbackItemStatistics> {
    const response = await this.svc.delete('/feedback', {
      data: this.serializer.serialize(deleteFeedbackRequest),
    });
    const responseData = this.serializer.deserialize<SubmitDeleteFeedbackResponse>(
      response.data,
      SubmitDeleteFeedbackResponse,
    );
    return responseData.feedbackItemStatistics;
  }

  public async listFeedback(
    listFeedbackRequest: ListFeedbackRequest,
  ): Promise<Array<FeedbackItemStatistics | null>> {
    const response = await this.svc.get(`/feedback/${listFeedbackRequest.ratingSystem}`, {
      params: {
        resourceIds: listFeedbackRequest.resourceIds,
        feedbackSource: listFeedbackRequest.feedbackSource,
      },
    });
    const responseData = this.serializer.deserialize<ListFeedbackStatisticsResponse>(
      response.data,
      ListFeedbackStatisticsResponse,
    );
    return responseData.feedbackItemStatistics;
  }

  public async getFeedbackByUser(
    getFeedbackByUser: GetFeedbackByUserRequest,
    userId: string,
  ): Promise<FeedbackItem | null> {
    const response = await this.svc.get(`/feedback/${getFeedbackByUser.resourceId}/${userId}`, {
      params: { feedbackSource: getFeedbackByUser.feedbackSource },
    });
    const responseData = response.data
      ? this.serializer.deserialize<GetFeedbackByUserResponse>(
          response.data,
          GetFeedbackByUserResponse,
        )
      : null;
    return responseData?.feedbackItem || null;
  }

  public async updateProposal(
    content: Content,
    contentAudience: ContentAudience,
    contentId?: string,
    onDuplicationEvent?: (event: DuplicationResultsResponse) => void,
    onContentId?: (contentId: string, workflowId: number) => void,
    signal?: AbortSignal,
  ): Promise<UpdateProposalResponse | null> {
    const sanitized = this.sanitizeWorkload(content);
    return updateProposalSSE(
      this.envConfig.mplServiceEndpoint,
      this.serializer,
      sanitized,
      contentAudience,
      async () => {
        const authInfo = await this.authenticationManager.renewAuthorInfo();
        if (authInfo) {
          this.setAuthentication(authInfo.tokenInfo.token);
          return authInfo.tokenInfo.token;
        }
        return undefined;
      },
      this.authenticationManager.authInfo?.tokenInfo?.token,
      contentId,
      onDuplicationEvent,
      onContentId,
      signal,
    );
  }

  private async listContentByStates(workflowStates: WorkflowState[] = []) {
    const listContentResponse = await Promise.all(
      workflowStates.map((wfState) => this.svc.get(`/contents?state=${wfState}`)),
    );
    const contentResponses: ListDraftContentsResponse[] =
      this.serializer.deserializeArray<ListDraftContentsResponse>(
        listContentResponse.map((res) => res.data),
        ListDraftContentsResponse,
      );
    // @ts-expect-error TS2769 - strict migration
    const workflows = contentResponses.reduce((acc, cur) => acc.concat(cur.workflows), []);
    return ListDraftContentsResponse.create(workflows);
  }

  private async deserializePublication(
    contentId: string,
    publicationResponse: any,
  ): Promise<Publication> {
    const publication = this.serializer.deserialize<GetPublicationResponse>(
      publicationResponse.data,
      GetPublicationResponse,
    );
    const attachmentIds = publication.content.attachments;
    // @ts-expect-error TS7034 - strict migration
    let pubAttachments = [];

    if (Array.isArray(attachmentIds) && attachmentIds.length > 0) {
      try {
        const getAttachmentReponse = await Promise.all(
          attachmentIds.map((attachmentId) =>
            this.svc.get(`/contents/${contentId}/attachment-info/${attachmentId}`),
          ),
        );
        const attachmentsInfo = this.serializer.deserializeArray<GetAttachmentInfoResponse>(
          getAttachmentReponse.map((res) => res.data),
          GetAttachmentInfoResponse,
        );
        pubAttachments = attachmentsInfo.map((i) => i.attachment);
      } catch (e) {
        localLog.debug('Failed to fetch attachments for content');
        pubAttachments = [];
      }
    }
    return this.serializer.deserialize<Publication>(
      {
        // @ts-expect-error TS7005 - strict migration
        attachments: pubAttachments,
        content: publication.content,
        workflowId: publication.workflowId,
        contentAudience: publication.contentAudience,
        contentOwner: this.serializer.serialize(publication.owner),
        publicationDate: publication.publicationDate,
        publicationState: publication.publicationState,
        publicationType: publication.publicationType,
      },
      Publication,
    );
  }

  /** Return a shallow copy of content with UI-only workload values stripped. */
  private sanitizeWorkload(content: Content): Content {
    return {
      ...content,
      templateMetadata: this.sanitizeTemplateMetadata(content.templateMetadata),
    } as Content;
  }

  /** Return a shallow copy of templateMetadata with UI-only workload values stripped. */
  private sanitizeTemplateMetadata(templateMetadata: any): any {
    if (!templateMetadata?.workload) return templateMetadata;
    return { ...templateMetadata, workload: stripWorkloadNotApplicable(templateMetadata.workload) };
  }
}

export default MplServiceClient;
